import {extractFileExtension} from '@kcast-fe/core';
import {TSvgName} from '@kcast-fe/ui-kit';

export const docsUtils = {
  getSvgIconByExtension: (docTitle: string): TSvgName => {
    const extension = extractFileExtension(docTitle);
    switch (extension) {
      case 'pdf':
        return 'File_PDF';
      case 'txt':
        return 'File_TXT';
      case 'csv':
      case 'tsv':
        return 'File_CSV';
      case 'doc':
      case 'dot':
        return 'File_DOC';
      case 'docx':
        return 'File_DOCX';
      case 'xls':
        return 'File_XLS';
      case 'xlsx':
        return 'File_XLSX';
      case 'ppt':
        return 'File_PPT';
      case 'pptx':
        return 'File_PPTX';
      case 'md':
        return 'File_MD';
      case 'xml':
        return 'File_XML';
      case 'yml':
      case 'yaml':
        return 'File_YML';
      case 'json':
        return 'File_JSON';
      case 'zip':
        return 'File_ZIP';
      case 'odt':
        return 'File_ODT';
      case 'ods':
        return 'File_ODS';
      case 'odp':
        return 'File_ODP';
      case 'epub':
        return 'File_EPUB';
      case 'rtf':
        return 'File_RTF';
      default:
        return 'File';
    }
  }
};
